import Config from '@/config';
import Vue from "vue";
import {end} from "@/utils/string";
import router from "@/router";
import {iso2DDMMYYYY} from "@/utils/date";
import {folderIMViews, isTaskWithDeadlineDays} from "@/utils/task";

const actions = {

    /* ----- confirmations ----- */

    confirm(store, params) {
        return new Promise((resolve, reject) => {
            store.rootState.ui.dialogConfirm.title = params?.title;
            store.rootState.ui.dialogConfirm.message = params?.message;
            store.rootState.ui.dialogConfirm.item = params?.item;
            store.rootState.ui.dialogConfirm.options = params?.options;
            store.rootState.ui.dialogConfirm.ok = params?.ok;
            store.rootState.ui.dialogConfirm.withHardConfirm = params?.withHardConfirm;
            store.rootState.ui.dialogConfirm.isInfo = params?.isInfo;
            store.rootState.ui.dialogConfirm.callback = (res) => {
                return resolve(res);
            };
            store.rootState.ui.dialogConfirm.isVisible = true;
        });
    },

    /* ----- dialogs ----- */

    /**
     * Generic dialog action.
     * Params.dialog specifies which dialog should be shown.
     * If there is a dialog specific action - will dispatch this particular action.
     * Returns promise.
     * @param store
     * @param params
     * @returns {Promise<unknown>|void|*}
     */
    dialog(store, params) {
        console.log("ui/dialog", params);
        if (!params.dialog) {
            return console.warn("dialog is not specified");
        }
        if (actions[params.dialog]) return actions[params.dialog](store, params);

        return new Promise((resolve, reject) => {
            let dialog = store.rootState.ui[params.dialog];
            Object.keys(params).forEach(key => dialog[key] = params[key]);
            dialog.item = params.item;
            dialog.callback = async (res) => {
                /*if (res) {
                    Object.keys(res).forEach(key => {
                        Vue.set(params.item, key, res[key]);
                    });
                }*/
                console.log("ui/dialog callback", res);
                if (typeof params.callback == "function") {
                    await params.callback(res);
                }

                return resolve(res);
            };
            //if ( !params.callback ) resolve();
            dialog.isVisible = true;
        });
    },
    dialogSelect(store, params) {
        if (!params?.item) return;

        return new Promise((resolve, reject) => {
            console.log("dialogSelect", params);
            store.rootState.ui.dialogSelect.item = params.item;
            store.rootState.ui.dialogSelect.prop = params.prop;
            store.rootState.ui.dialogSelect.title = params.title || null;
            store.rootState.ui.dialogSelect.label = params.label || null;
            store.rootState.ui.dialogSelect.text = params.text || null;
            store.rootState.ui.dialogSelect.popularOptions = params.popularOptions || null;
            store.rootState.ui.dialogSelect.options = params.options || null;
            store.rootState.ui.dialogSelect.callback = res => resolve(res);
            store.rootState.ui.dialogSelect.isVisible = true;
        });
    },
    dialogContextSelector(store, params) {
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.dialogContextSelector,
                params
            }, {root: true});
        });
    },
    dialogUser(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogUser", params);
            store.rootState.ui.dialogUser.tabIndex = params?.tabIndex || 0;
            store.rootState.ui.dialogUser.callback = (res) => resolve(res);
            store.rootState.ui.dialogUser.isVisible = true;
        });
    },
    dialogPick(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogPick", params);
            store.rootState.ui.dialogPick.item = params?.item;
            store.rootState.ui.dialogPick.callback = (res) => resolve(res);
            store.rootState.ui.dialogPick.isVisible = true;
        });
    },
    dialogGroup(store, params) {
        return new Promise((resolve, reject) => {
            //console.log("dialogGroup", params);
            store.rootState.ui.dialogGroup.item = params?.item;
            store.rootState.ui.dialogGroup.tabIndex = params?.tabIndex || 0;
            store.rootState.ui.dialogGroup.callback = (res) => resolve(res);
            store.rootState.ui.dialogGroup.isVisible = true;
        });
    },
    dialogTopic(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogTopic", params);
            store.rootState.ui.dialogTopic.contextId = params?.contextId;
            store.rootState.ui.dialogTopic.item = params?.item;
            store.rootState.ui.dialogTopic.callback = (res) => {
                /*router.push({
                    name: "context",
                    params: {
                        contextId: res.contextId
                    }
                });*/

                return resolve(res);
            };
            store.rootState.ui.dialogTopic.isVisible = true;
        });
    },
    dialogFolder(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogFolder", params);
            store.rootState.ui.dialogFolder.contextId = params?.contextId;
            store.rootState.ui.dialogFolder.parentId = params?.parentId;
            store.rootState.ui.dialogFolder.item = params?.item;
            store.rootState.ui.dialogFolder.callback = res => resolve(res);
            store.rootState.ui.dialogFolder.isVisible = true;
        });
    },
    /*dialogTaskDone(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogTaskDone", params);
            store.rootState.ui.dialogTaskDone.item = params.item;
            store.rootState.ui.dialogTaskDone.callback = (res) => {
                //console.log("CALLBACK", res);
                if ( res ) {
                    Object.keys(res).forEach(key => {
                        Vue.set(params.item, key, res[key]);
                    });
                }
                return resolve(res);
            };
            store.rootState.ui.dialogTaskDone.isVisible = true;
        });
    },
    dialogTaskDefer(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogTaskDefer", params);
            store.rootState.ui.dialogTaskDefer.item = params.item;
            store.rootState.ui.dialogTaskDefer.callback = (res) => {
                //console.log("CALLBACK", res);
                if ( res ) {
                    Object.keys(res).forEach(key => {
                        Vue.set(params.item, key, res[key]);
                    });
                }
                return resolve(res);
            };
            store.rootState.ui.dialogTaskDefer.isVisible = true;
        });
    },
    /!**
     * todo rename to dialogTaskDelay
     * @param store
     * @param params
     * @returns {Promise<unknown>}
     *!/
    dialogDelay(store, params) {
        return new Promise((resolve, reject) => {
            console.log("dialogDelay", params);
            store.rootState.ui.dialogDelay.item = params.item;
            store.rootState.ui.dialogDelay.callback = (res) => {
                //console.log("CALLBACK", res);
                Object.keys(res).forEach(key => {
                    Vue.set(params.item, key, res[key]);
                });
                return resolve(res);
            };
            store.rootState.ui.dialogDelay.isVisible = true;
        });
    },*/
    dialogTaskDeadline(store, params) {
        console.log("ui/dialogTaskDeadline", params);
        //if (!params?.item?.id) return;

        // for templates and repeated tasks we only allow to select a day interval
        if (isTaskWithDeadlineDays(params.item)) return new Promise((resolve, reject) => {
            store.rootState.ui.dialogSelect.item = params.item;
            store.rootState.ui.dialogSelect.prop = "deadlineDays";
            store.rootState.ui.dialogSelect.title = "Укажите дедлайн";
            store.rootState.ui.dialogSelect.label = "Выбрать другой срок";
            store.rootState.ui.dialogSelect.text = params.item.isTemplate ? "Дедлайн будет установлен от даты активации шаблона." : "Дедлайн будет установлен от даты появления повторяющейся задачи.";
            store.rootState.ui.dialogSelect.popularOptions = [
                {value: 1, text: "1 день"},
                {value: 2, text: "2 дня"},
                {value: 3, text: "3 дня"},
                {value: 4, text: "4 дня"},
                {value: 5, text: "5 дней"},
                {value: 6, text: "6 дней"},
                {value: 7, text: "1 неделя", width: "47.5%"},
                {value: 14, text: "2 недели", width: "47.5%"},
                //{value:30, text:"1 месяц"},
            ];
            store.rootState.ui.dialogSelect.options = [...new Array(90)].map((el, index) => ({
                text: (index + 1) + " " + end(index + 1, "день", "дня", "дней"),
                value: index + 1,
            }));
            store.rootState.ui.dialogSelect.callback = (res) => {
                console.log("Selected days", res.deadlineDays);
                if (!res.deadlineDays) res.deadline = null;
                if (res) resolve(res);
                else reject();
            };
            store.rootState.ui.dialogSelect.isVisible = true;
        });
        // for regular tasks - show calendar
        else return new Promise((resolve, reject) => {

            const minDate = new Date();
            minDate.setDate(minDate.getDate() - 14);
            store.rootState.ui.dialogCalendar.item = params.item;
            store.rootState.ui.dialogCalendar.title = "Укажите дедлайн";
            if (params.item?.deadline) {
                store.rootState.ui.dialogCalendar.text = "Текущий дедлайн: " + iso2DDMMYYYY(params.item.deadline);
            }
            store.rootState.ui.dialogCalendar.prop = "deadline";
            store.rootState.ui.dialogCalendar.minDate = minDate;
            store.rootState.ui.dialogCalendar.callback = res => {
                if (res) resolve(res);
                else reject();
            }
            store.rootState.ui.dialogCalendar.isVisible = true;
        });
    },
    /**
     * todo rename to dialogTaskMove
     * @param store
     * @param params
     * @returns {Promise<unknown>}
     */
    dialogMove(store, params) {
        return new Promise((resolve, reject) => {
            store.rootState.ui.dialogTaskMove.items = params.items;
            store.rootState.ui.dialogTaskMove.contextId = params.contextId;
            store.rootState.ui.dialogTaskMove.fromContextId = params.fromContextId;
            store.rootState.ui.dialogTaskMove.place = params.place;
            store.rootState.ui.dialogTaskMove.excludedContextIds = params.excludedContextIds;
            store.rootState.ui.dialogTaskMove.callback = (res) => {
                console.log("ui/dialogMove RES", res);
                return resolve(res);
            };
            store.rootState.ui.dialogTaskMove.isVisible = true;
        });
    },
    /**
     * todo this is not a dialog - this is a menu
     * @param store
     * @param params
     * @returns {Promise<unknown>}
     */
    dialogFolderIMView(store, params) {
        if (!params?.item?.id) return;

        return actions.valueSelector(store, {
            ...params,
            prop: "folderIMView",
            text: "Задачи папки при просмотре родительской<br/>задачи отображается:",
            items: folderIMViews
        });

        /*return new Promise((resolve, reject) => {

            console.log("dialogFolderIMView", params);
            store.rootState.ui.dialogSelect.item = params.item;
            store.rootState.ui.dialogSelect.prop = "folderIMView";
            store.rootState.ui.dialogSelect.label = "Отображение";
            store.rootState.ui.dialogSelect.title = "Отображение в мессенджере";
            store.rootState.ui.dialogSelect.text = "Как задачи данной папки отображаются в мессенджере при просмотре родительской группы.";
            store.rootState.ui.dialogSelect.popularOptions = [
                {value: 1, text: "только первая задача"},
                {value: 2, text: "все задачи"},
                {value: 3, text: "не отображаются"},
            ];
            /!*store.rootState.ui.dialogSelect.options = [...new Array(90)].map((el, index) => ({
                text: (index + 1) + " " + end(index + 1, "день", "дня", "дней"),
                value: index + 1,
            }));*!/
            store.rootState.ui.dialogSelect.callback = (res) => {
                console.log("Selected value", res.folderIMView);
                if (!res.folderIMView) res.folderIMView = null;
                return resolve(res);
            };
            store.rootState.ui.dialogSelect.isVisible = true;
        });*/

    },

    /* ----- snacks ----- */


    snack(store, params) {
        //console.log("ui/snack", params);
        let snackName = "snack";
        if (params.snack && params.snack !== snackName) {
            snackName = params.snack;
            if (actions[snackName]) return actions[snackName];
        }

        return new Promise((resolve, reject) => {
            console.log("ui/snack", params);
            let snack = store.rootState.ui[snackName];
            Object.keys(params).forEach(key => snack[key] = params[key]);
            //snack.item = params.item;
            snack.callback = async (res) => {
                //console.log("ui/snack CALLBACK", res);
                if (res) {
                    Object.keys(res).forEach(key => {
                        Vue.set(params.item, key, res[key]);
                    });
                }
                if (typeof params.callback == "function") {
                    await params.callback(res);
                }

                return resolve(res);
            };

            snack.isVisible = true;
        });
    },

    /* ----- selectors ----- */

    valueSelector(store, params) {
        //console.log("valueSelector");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.valueSelector,
                params
            }, {root: true});
        });
    },
    tagSelector(store, params) {
        //console.log("tagSelector");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.tagSelector,
                params
            }, {root: true});
        });
    },
    prioSelector(store, params) {
        //console.log("prioSelector");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.prioSelector,
                params
            }, {root: true});
        });
    },
    colorSelector(store, params) {
        //console.log("colorSelector");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.colorSelector,
                params
            }, {root: true});
        });
    },
    rangeSelector(store, params) {
        //console.log("rangeSelector");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.rangeSelector,
                params
            }, {root: true});
        });
    },

    /* ----- menus ----- */

    menu(store, params) {
        if (!params.menu) {
            return console.warn("menu is not specified");
        }
        if (actions[params.menu]) return actions[params.menu](store, params);
        console.log("menu", params);
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui[params.menu],
                params
            }, {root: true});
        });
    },
    contextMenu(store, params) {
        //console.log("contextMenu");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.contextMenu,
                params
            }, {root: true});
        });
    },
    prioMenu(store, params) {
        //console.log("prioMenu");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.prioMenu,
                params
            }, {root: true});
        });
    },
    assigneeMenu(store, params) {
        //console.log("assigneeMenu");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.assigneeMenu,
                params
            }, {root: true});
        });
    },
    userMenu(store, params) {
        //console.log("userMenu");
        return this.assigneeMenu(store, params);
    },
    assignmentMenu(store, params) {
        //console.log("assignmentMenu");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.assignmentMenu,
                params
            }, {root: true});
        });
    },
    groupMenu(store, params) {
        //console.log("userMenu");
        return new Promise((resolve, reject) => {
            params.callback = (res) => resolve(res);
            store.commit('uiMenu', {
                menu: store.rootState.ui.groupMenu,
                params
            }, {root: true});
        });
    },
};

export default actions;
